import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import { getAutoComplete } from "../../api/getAutoComplete";

function QuestionConVial() {

  const [respuestaSeleccionada, setRespuestaSeleccionada] = useState("");
  const [preguntasAll, setPreguntasAll] = useState([]);
  const [preguntaActual, setPreguntaActual] = useState([]);
  const [loading, setLoading] = useState(false);
  const [validateButtonNextQ, setValidateButtonNextQ] = useState(false);
  const isRunned = useRef(false);

  useEffect
    (() => {

      if (isRunned.current) return;
      isRunned.current = true;

      async function createSession() {

        setLoading(true);
        const dataJson = await getAutoComplete();
        setPreguntasAll(dataJson);
        setPreguntaActual(dataJson.preguntas[0]);
        setLoading(false);

      }
      createSession();
    }, []);

  function handleRespuestaSeleccionada(respuesta) {
    setValidateButtonNextQ(true);
    setRespuestaSeleccionada(respuesta);
  }

  function handleSiguientePregunta() {
    const indicePreguntaActual = preguntasAll.preguntas.findIndex(
      (pregunta) => pregunta.id === preguntaActual.id
    );
    if (indicePreguntaActual < preguntasAll.preguntas.length - 1) {
      setPreguntaActual(preguntasAll.preguntas[indicePreguntaActual + 1]);
      setRespuestaSeleccionada("");
      setValidateButtonNextQ(false);
    } else {
      onTest();
    }
  }

  const navigate = useNavigate();

  const onTest = async () => {
    navigate("/ValidarData", {
      state: {
        preguntas: preguntasAll
      }
    });
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/PantallaBase27"
          title="Conocimiento vial"
          name="QuestionConVial"
        />
        {loading ? (
          <div className="containerRender">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="containerRender">
            <div className="containerInfo_P2">
              <div className="containerIdent_P2">
                <div className="tiitleExp animate__animated animate__fadeIn">{preguntaActual.seccion}</div>
                <hr className="colorCFCFCF" />
                <div>
                  <div className="textQuestion animate__animated animate__fadeIn">{preguntaActual.pregunta}</div>
                  <div>
                    <Select
                      placeholder="Selecciona una respuesta"
                      value={respuestaSeleccionada}
                      onChange={handleRespuestaSeleccionada}
                      options={preguntaActual.respuestas?.map((respuesta) => ({
                        label: respuesta,
                        value: respuesta,
                      }))}
                    />
                  </div>
                  <hr className="colorCFCFCF" />
                  {!validateButtonNextQ ? (
                    <>
                      <button className='btnVer_P3'>
                        <span className='txtVer_P3'>Continuar</span>
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        className="button_P2 animate__animated animate__fadeIn"
                        onClick={handleSiguientePregunta}>
                        <span className="txtButton_P2">Continuar</span>
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default QuestionConVial;
